import React from 'react';
import {vuepayAlert} from "../../../../util/utility";
import {Button, Col, Container, Row} from 'reactstrap';
import "../common.css"
import "./index.css"
import {MyLibraryComponent} from "../../../../components/clipstore/broadcaster/library";
import {VideoPlayerModal} from "../../../../components/modal/clipstore/broadcaster/VideoPlayerModal";
import {connect} from "react-redux";
import * as actions from "../../../../actions";
//API
import api from "../../../../util/clipstore/broadcaster/library";
import {UploadFileModal} from "../../../../components/modal/clipstore/broadcaster/UploadFileModal";
import {EditVideoModal} from "../../../../components/modal/clipstore/broadcaster/EditVideoModal";

class MyLibraryHomePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 96,
            height: 54,
            searchValue: '',
            sortBy: 'new',
            selectAllCheckbox: false,
            checkboxStore: [],
            currentVideoId: null,
            currentVideo: null,
            signedURL: '',
            uploadContent: false,
            isEditModalOpen: false,

            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            content: {},
            contentList: [],
        }

        this.getMyLibrary = this.getMyLibrary.bind(this);
        this.editVideo = this.editVideo.bind(this);
        this.updateSearchValue = this.updateSearchValue.bind(this);
    }

    componentDidMount() {
        api.getMyLibraryAPI(this.props, {
            width: this.state.width,
            height: this.state.height,
            searchValue: this.state.searchValue,
            sortBy: this.state.sortBy,
            page: this.state.currentPage,
        });
    }

    loadNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;

        this.setState({
            currentPage
        }, () => {
            api.getMyLibraryAPI(this.props, {
                width: this.state.width,
                height: this.state.height,
                searchValue: this.state.searchValue,
                sortBy: this.state.sortBy,
                page: this.state.currentPage,
            });
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        //this will be called for every pagination we perform
        if (nextProps.get_my_library && nextProps.get_my_library.payload !== this.props.get_my_library.payload) {

            if (nextProps.get_my_library.payload &&
                nextProps.get_my_library.payload.hasOwnProperty("data")) {

                let data = nextProps.get_my_library.payload;
                let contentList = data.data;

                if (this.state.currentPage !== 1) {
                    if (contentList.length > 0) {
                        contentList = this.state.contentList.concat(contentList)
                    } else {
                        contentList = this.state.contentList;
                    }
                }

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.length,
                    totalItems: parseInt(data.total),
                    contentList,
                    reset: false
                }, () => {

                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    }
                })
            }
        }

        if (nextProps.duplicate_videos && nextProps.duplicate_videos.payload != null) {

            //reset the payload value as we have captured the event
            this.props.resetDuplicateVideos();

            if (nextProps.duplicate_videos.payload.hasOwnProperty("success") && nextProps.duplicate_videos.payload.success.hasOwnProperty("message")) {
                //refresh the library
                vuepayAlert("success", nextProps.duplicate_videos.payload.success.message)
                this.getMyLibrary(true);
            } else if (nextProps.duplicate_videos.hasOwnProperty("isError") && nextProps.duplicate_videos.isError) {
                if(nextProps.duplicate_videos.payload.hasOwnProperty("message")){
                    vuepayAlert("error",nextProps.duplicate_videos.payload.message)
                }
            }
        }

        if (nextProps.delete_videos && nextProps.delete_videos.payload != null) {

            //reset the payload value as we have captured the event
            this.props.resetDeleteVideos();

            if (nextProps.delete_videos.payload.hasOwnProperty("success") && nextProps.delete_videos.payload.success.hasOwnProperty("message")) {
                //refresh the library
                vuepayAlert("success", nextProps.delete_videos.payload.success.message)
                this.getMyLibrary(true);
            } else if (nextProps.delete_videos.hasOwnProperty("isError") && nextProps.delete_videos.isError) {
                if (nextProps.delete_videos.payload.hasOwnProperty("message")) {
                    vuepayAlert("error", nextProps.delete_videos.payload.message)
                }
            }
        }

        if (nextProps.retry_video_url && nextProps.retry_video_url.payload != null) {

            //reset the payload value as we have captured the event
            this.props.resetUploadLink();

            if (nextProps.retry_video_url.payload.hasOwnProperty("success") && nextProps.retry_video_url.payload.success.hasOwnProperty("message")) {
                //refresh the library
                //vuepayAlert("success",nextProps.retry_video_url.payload.success.message)
                this.setSignedURL(nextProps.retry_video_url.payload.success.data.url);

            } else if (nextProps.retry_video_url.hasOwnProperty("isError") && nextProps.retry_video_url.isError) {
                if (nextProps.retry_video_url.payload.hasOwnProperty("message")) {
                    vuepayAlert("error", nextProps.retry_video_url.payload.message)
                }
            }
        }
    }

    editVideo(id) {
        const result = this.state.contentList.filter(content => content.id === id);

        if (Array.isArray(result) && result.length > 0) {
            this.setState({
                contentForPricing: result[0],
                isEditModalOpen: true
            }, () => {
                this.props.setAddEditPricing(result[0])
            });
        }
    }

    setSignedURL = (url) => {
        this.setState({
            signedURL: url
        })
    }

    resetSignedURL = () => {
        this.setSignedURL("");
        this.setUploadContent(false);
    }

    setCurrentVideoId = (id) => {
        this.setState({
            currentVideoId: id
        }, () => {
            this.state.contentList.map((content) => {
                if (content.id === id) {
                    this.setCurrentVideo(content)
                }
            });
        })
    }

    resetCurrentVideoId = () => {
        this.setCurrentVideoId(null);
    }

    setCurrentVideo = (obj) => {
        this.setState({
            currentVideo: obj
        })
    }

    setUploadContent = (uploadContent) => {
        this.setState({
            uploadContent
        })
    }

    setEditVideoModal = (isEditModalOpen) => {
        this.setState({
            isEditModalOpen
        })
    }

    getMyLibrary = (reset = false) => {

        this.setState({
            selectAllCheckbox: false,
            checkboxStore: []
        });


        if (reset) {
            this.setState({
                currentPage: 1,
                totalPages: 1,
                currentItems: 12,
                totalItems: 12,
                reset: true,
                hasMore: true,
                content: {},
                contentList: [],
            }, () => {
                //refresh the page
                api.getMyLibraryAPI(this.props, {
                    width: this.state.width,
                    height: this.state.height,
                    searchValue: this.state.searchValue,
                    sortBy: this.state.sortBy,
                    page: this.state.currentPage,
                });
            })
        } else {
            api.getMyLibraryAPI(this.props, {
                width: this.state.width,
                height: this.state.height,
                searchValue: this.state.searchValue,
                sortBy: this.state.sortBy,
                page: this.state.currentPage,
            });
        }

    }

    updateSearchValue = (e) => {
        let target = '', value = '';
        if (e) {
            target = e.target.name;
            value = e.target.value;
        }

        this.setState({
            searchValue: value
        }, () => {
            if (e === null) {
                this.getMyLibrary(true);
            }
        })
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (e.target.value.trim().length >= 1) {
                this.getMyLibrary(true);
            }
        }
    }

    setSortBy = (sortBy) => {
        this.setState({
            sortBy
        }, () => {
            this.getMyLibrary();
        })
    }

    selectAllToggle = () => {
        this.setState({
            selectAllCheckbox: !this.state.selectAllCheckbox,
            checkboxStore: []
        }, () => {
            if (this.state.selectAllCheckbox) {
                let videoIds = [];
                this.state.contentList.map((content) => {
                    videoIds.push(content.id);
                });

                this.setState({
                    checkboxStore: videoIds
                }, () => {
                })
            }
        });
    };

    checkboxToggle = (event) => {
        const stringToIntValue = event.target.value;
        let videoIds = [...this.state.checkboxStore];
        let present = videoIds.includes(stringToIntValue);
        if (present) {
            //remove and update the state
            videoIds = videoIds.filter((id) => {
                return id !== stringToIntValue
            });
        } else {
            //please add into the array
            videoIds.push(stringToIntValue)
        }

       
        this.setState({
            selectAllCheckbox: this.state.contentList.length === videoIds.length,
            checkboxStore: videoIds,
        });

    };

    uploadContent = () => {
        this.setUploadContent(true);
    }

    deleteMany = () => {
        this.deleteVideo(this.state.checkboxStore)
    }

    publishMany = () => {
        this.props.history.push(`/broadcaster/my-library/publish?ids=${this.state.checkboxStore.join()}`);

    }

    publishVideo = (id) => {
        this.props.history.push(`/broadcaster/my-library/publish?ids=${id}`);
    }

    duplicateVideo = (id) => {
        let idArray = api.getVideoOrPictureArray(this.state.contentList, id);
        api.duplicateVideosAPI(this.props, idArray["videoIdArray"], idArray["pictureIdArray"])
    }

    deleteVideo = (id) => {
        let idArray = api.getVideoOrPictureArray(this.state.contentList, id);
        api.onDelete(this.props, idArray["videoIdArray"], idArray["pictureIdArray"])
    }

    getVideoLink = (id) => {
        this.setCurrentVideoId(id);
        api.getUploadVideoLinkAPI(this.props, id);
    }

    thumbnailClicked = (id) => {
        const result = this.state.contentList.filter(content => content.id === id);
        if (Array.isArray(result) && result.length > 0) {
            this.props.showBroadcasterVideoPlayerModal({
                video: result[0],
                action: {
                    text: "CLOSE",
                    click: () => {

                    }
                }
            });
        }
    }

    render() {


        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container other-middle-container">
                            <Container className="my-library-home-container-no-min-height no-padding">
                                <Row className="display-flex-vertical-center no-margin border-bottom"
                                     style={{padding: 16}}>
                                    <Col sm="6" className="my-library-title no-padding text-align-left ">My
                                        Library</Col>
                                    <Col sm="6" className="no-padding  text-align-right">
                                        <Button color="primary" onClick={this.uploadContent}>
                                            UPLOAD CONTENT
                                        </Button>
                                    </Col>
                                </Row>


                                {
                                    this.props.flag.hasOwnProperty("showBroadcasterVideoPlayerModal") &&
                                    this.props.flag.hasOwnProperty("broadcasterVideoPlayerModalPayload") &&
                                    this.props.flag.broadcasterVideoPlayerModalPayload.hasOwnProperty("video") &&
                                    this.props.flag.broadcasterVideoPlayerModalPayload.video !== null &&
                                    <VideoPlayerModal
                                        isOpen={this.props.flag.showBroadcasterVideoPlayerModal}
                                        video={this.props.flag.broadcasterVideoPlayerModalPayload.video}
                                        action={this.props.flag.broadcasterVideoPlayerModalPayload.action}
                                        hideVideoPlayerModal={this.props.hideBroadcasterVideoPlayerModal}
                                    />
                                }

                                {
                                    this.state.isEditModalOpen &&
                                    <EditVideoModal
                                        isOpen={this.state.isEditModalOpen}
                                        toggle={(key) => {
                                            this.setEditVideoModal(false);

                                            if (key === "refresh") {
                                                this.getMyLibrary(true);
                                            }
                                        }}
                                        history={this.props.history}
                                    />
                                }

                                <UploadFileModal
                                    history={this.props.history}
                                    isOpen={(this.state.signedURL !== "" || this.state.uploadContent)}
                                    toggle={this.resetSignedURL}
                                    uploadContent={this.state.uploadContent}
                                    signedURL={this.state.signedURL}
                                    currentVideo={this.state.currentVideo}
                                    onError={(message) => {
                                        api.onErrorUpload(this.props, this.state.currentVideoId)
                                    }}
                                    onFinish={(signResult) => {
                                        api.onFinishUpload(this.props, signResult, this.getMyLibrary)
                                    }}
                                    setVideoContent={this.props.setVideoContent}
                                />

                                <MyLibraryComponent
                                    uploadContent={this.uploadContent}

                                    searchValue={this.state.searchValue}
                                    updateSearchValue={this.updateSearchValue}
                                    handleKeyPress={this.handleKeyPress}

                                    sortBy={this.state.sortBy}
                                    setSortBy={this.setSortBy}

                                    selectAllCheckbox={this.state.selectAllCheckbox}
                                    selectAllToggle={this.selectAllToggle}
                                    checkboxStore={this.state.checkboxStore}
                                    checkboxToggle={this.checkboxToggle}

                                    deleteMany={this.deleteMany}
                                    publishMany={this.publishMany}

                                    thumbnailClicked={this.thumbnailClicked}
                                    editVideo={this.editVideo}

                                    publishVideo={this.publishVideo}
                                    duplicateVideo={this.duplicateVideo}
                                    deleteVideo={this.deleteVideo}
                                    getVideoLink={this.getVideoLink}

                                    hasMore={this.state.hasMore}
                                    my_library={this.props.get_my_library}
                                    contentList={this.state.contentList}
                                    loadNextPage={this.loadNextPage}
                                />

                            </Container>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_my_library: state.clipstore_broadcaster_get_my_library,
        duplicate_videos: state.clipstore_broadcaster_duplicate_videos,
        delete_videos: state.clipstore_broadcaster_delete_videos,
        publish_videos: state.clipstore_broadcaster_publish_videos,
        retry_video_url: state.clipstore_broadcaster_retry_video_url,
        flag: state.flag
    };
}

export default connect(mapStateToProps, actions)(MyLibraryHomePage);